export default function DropdownArrowIcon({ className, style, open = false }) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: 24,
        height: 24,
        pointerEvents: "none",
        transform: open ? "rotate(180deg)" : "rotate(0deg)",
        transition: "transform 160ms ease",
        ...style,
      }}
      aria-hidden="true"
      focusable="false"
    >
      <mask
        id="dropdown-arrow-mask"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#dropdown-arrow-mask)">
        <path
          d="M11.3003 14.3L8.70026 11.7C8.38359 11.3833 8.31292 11.021 8.48826 10.613C8.66292 10.2043 8.97526 10 9.42526 10H14.5753C15.0253 10 15.3376 10.2043 15.5123 10.613C15.6876 11.021 15.6169 11.3833 15.3003 11.7L12.7003 14.3C12.6003 14.4 12.4919 14.475 12.3753 14.525C12.2586 14.575 12.1336 14.6 12.0003 14.6C11.8669 14.6 11.7419 14.575 11.6253 14.525C11.5086 14.475 11.4003 14.4 11.3003 14.3Z"
          fill="black"
          fillOpacity="0.5"
        />
      </g>
    </svg>
  );
}
